import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed, ref } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { CodeUpdateDocument, CodeType, OrganizationType } from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BModal,
  BSpinner,
} from 'bootstrap-vue-next';
import OrganizationPicker from '@/components/organization/OrganizationPicker.vue';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'CodeUpdate',
  props: {
    code: {},
    show: { type: Boolean }
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const show = computed<boolean>(() => {
  return props.show;
});

const newOrderRef = ref<string | null>(props.code.orderRef || null);
const newComment = ref<string | null>(props.code.comment || null);
const newOrganization = ref<OrganizationType | null>(
  props.code.organization || null
);

// --- Mutation ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(CodeUpdateDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.codeUpdate) {
    console.debug('Code updated:', res.data.codeUpdate);
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value = 'Code update failed: ' + res.data;
    console.error('Code update failed:', res.data);
  }
});
onMutationError((err) => {
  console.error('Error updating code:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handlers ---
function close() {
  emits('close');
}

function updateRequested() {
  console.debug('Update requested');

  if (!props.code.id) {
    mutationError.value = 'Code ID is missing';
    console.error('Code ID is missing');
    return;
  }

  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({
    id: props.code.id,
    orderRef: newOrderRef.value,
    comment: newComment.value,
    organizationId: newOrganization.value?.id || null,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((show).value = $event)),
      onHide: close
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "barcode",
          class: "me-2"
        }),
        _createTextVNode(" " + _toDisplayString(__props.code.code?.toUpperCase()) + " coupon ", 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          onClick: close,
          variant: "secondary"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          onClick: updateRequested,
          disabled: mutationInProgress.value || mutationShowSuccess.value,
          variant: "primary"
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Updating Code ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Code Updated ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, " Update Code "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(OrganizationPicker, {
            class: "mt-3",
            modelValue: newOrganization.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newOrganization).value = $event)),
            label: "Organization",
            allowNullOrganization: true,
            includeOwnerFullName: true,
            includeOwnerEmail: true,
            includeCountryCode: true
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(BFormGroup), {
            label: "Order reference",
            "label-for": "new-order-ref",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormInput), {
                modelValue: newOrderRef.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newOrderRef).value = $event)),
                id: "new-order-ref",
                name: "new-order-ref",
                type: "text",
                placeholder: "Enter your custom order reference"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BFormGroup), {
            label: "Comment",
            "label-for": "new-comment",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormTextarea), {
                modelValue: newComment.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newComment).value = $event)),
                id: "new-comment",
                name: "new-comment",
                placeholder: "Enter a new comment"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BAlert), {
            modelValue: mutationError.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mutationError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[4] || (_cache[4] = ($event: any) => (mutationError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mutationError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})